import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export type UserCoursesTabValue = 'in-progress' | 'ready-to-start' | 'completed';

export interface UserCoursesTabPill {
  label: string;
  value: UserCoursesTabValue;
  count: number;
}

@Component({
  selector: 'l-user-courses-pills',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pills.component.html',
})
export class UserCoursesPillsComponent {

  @Input({ required: true })
  public pills: UserCoursesTabPill[] = [];

  @Input({ required: true })
  public activeTab!: UserCoursesTabValue;

  @Output()
  public activeTabChange: EventEmitter<UserCoursesTabValue> = new EventEmitter<UserCoursesTabValue>();

  public selectTab(tab: UserCoursesTabValue): void {
    this.activeTabChange.emit(tab);
  }
}
